import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError, isNotFoundError } from "@utils/errorHandler";

import {
  loadAllSite,
  loadSingleSite,
  setSingleSiteNotFound,
} from "./SiteList.slice";

import { loadAllSiteAPI, loadSingleSiteAPI } from "./SiteList.api";

export const LOAD_ALL_SITE = {
  LOADING: "Load all site loading",
  SUCCESS: "Load all site success",
  ERROR: "Load all site error",
};

export const LOAD_SINGLE_SITE = {
  LOADING: "Load single site loading",
  SUCCESS: "Load single site success",
  ERROR: "Load single site error",
};

function* loadAllSiteWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllSiteAPI, payload);
    yield put(loadAllSite(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_SITE.ERROR, error });
  }
}

function* loadSingleSiteSagaWorker(action) {
  yield put(setSingleSiteNotFound(false));
  const { payload } = action;

  try {
    const data = yield call(loadSingleSiteAPI, payload);
    yield put(loadSingleSite(data));
  } catch (error) {
    if (isNotFoundError(error)) {
      yield put(setSingleSiteNotFound(true));
      return;
    }
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_SITE.ERROR, error });
  }
}

export function* loadAllSiteSaga() {
  yield takeLatest(LOAD_ALL_SITE.LOADING, loadAllSiteWorker);
}

export function* loadSingleSiteSaga() {
  yield takeLatest(LOAD_SINGLE_SITE.LOADING, loadSingleSiteSagaWorker);
}
